import { useState } from "react";
import { Card, CardBody } from "reactstrap";

import JustifyTabs from "../../CommonElements/JustifyTabs";
import { scheduledAssessmentTabs } from "../../utils/helper/helper";
import useIsMobile from "../../utils/helper/responsive";

import ScheduledAssessments from "./ScheduledAssessments/AssessmentReview";
import StandaloneSchedules from "./ScheduledAssessments/StandaloneSchedules";

const ScheduledAssessmentsTab = () => {
  const [activeTab, setActiveTab] = useState("assessment_review");
  const isMobile = useIsMobile();

  const handleTabClick = tabId => {
    setActiveTab(tabId);
  };

  return (
    <div className="page-body page-body-margin schedule-assessments">
      <Card className="p-1">
        <CardBody>
          <div
            className={`d-md-flex flex-column flex-md-row justify-content-between ${!isMobile ? "align-items-center" : ""}`}
          >
            <div className="mb-1 mb-sm-0 d-flex flex-column gap-2 align-items-md-center">
              <JustifyTabs
                tabs={scheduledAssessmentTabs}
                activeTab={activeTab}
                onTabClick={handleTabClick}
              />
            </div>
            <div className="d-md-flex justify-content-end align-items-center mt-sm-0 mt-2 gap-4 ms-auto"></div>
          </div>
        </CardBody>
      </Card>

      {activeTab === "assessment_review" && <ScheduledAssessments />}
      {activeTab === "standalone_schedules" && <StandaloneSchedules />}
    </div>
  );
};

export default ScheduledAssessmentsTab;
